module.exports = {
  Logger: function() {
    return console;
  }
};
